'use client';

import { useRouter } from 'next/navigation';
import type React from 'react';
import { useCallback } from 'react';
import { useApp } from '@/forApp/states/appState/appState';
import Button from '@/shared/Buttons/Button';
import { Icons } from '@/shared/Icons/Icons';
import Tabs, { type TabItem } from '@/shared/Tabs/Tabs';
import FormSearch from '@/widgets/MainBlock/MainSearch/FormSearch/FormSearch';
import type { DefaultFilterT } from '@/widgets/MainBlock/MainSearch/types';
import { DEFAULT_SEARCH_TYPE } from '@/forApp/utils/constants';
import { getRouteHref, ROUTES } from '@/forApp/utils/routes';

import styles from './styles.module.css';

type MainSearchT = {
  defaultFilter: DefaultFilterT;
};

const tabs: TabItem[] = [
  { title: 'Купить', value: 'sale' },
  { title: 'Снять', value: 'rent' },
];

const MainSearchMobile: React.FC<MainSearchT> = ({ defaultFilter }) => {
  const { filters, setFilters } = useApp();
  const router = useRouter();

  const handleSearch = useCallback(
    (typeSearch?: string) => {
      try {
        const chosenType =
          (filters?.extraType as string) ||
          (filters?.type as string) ||
          DEFAULT_SEARCH_TYPE;
        const city = (filters?.['filters[city]'] as string) || '';
        const adType = (filters?.['filters[ad_type]'] as string) || '';
        const params = new URLSearchParams();
        Object.entries(filters || {}).forEach(([key, value]) => {
          if (key === 'type') return;
          if (key === 'extraType') return;
          if (key === 'filters[city]') return;
          if (key === 'filters[ad_type]') return;
          if (value === undefined || value === null) return;
          if (Array.isArray(value)) {
            value
              .filter((v) => v !== '' && v !== null && v !== undefined)
              .forEach((v) => params.append(key, String(v)));
          } else {
            const v = String(value);
            if (v !== '') params.append(key, v);
          }
        });
        let href = getRouteHref(
          typeSearch === 'maps' ? ROUTES.MAP : ROUTES.CATALOG,
          { type: chosenType },
        );
        if (adType) {
          params.set('filters[ad_type]', adType);
        }
        const finalQs = params.toString();
        if (finalQs) href += `?${finalQs}`;
        router.push(href);
      } catch {
        const chosenType =
          (filters?.extraType as string) ||
          (filters?.type as string) ||
          DEFAULT_SEARCH_TYPE;
        // const city = (filters?.['filters[city]'] as string) || '';
        // const adType = (filters?.['filters[ad_type]'] as string) || '';
        router.push(
          getRouteHref(typeSearch === 'maps' ? ROUTES.MAP : ROUTES.CATALOG, {
            type: chosenType,
          }),
        );
      }
    },
    [filters, router],
  );

  return (
    <div className={styles.mainSearch}>
      <Tabs
        tabs={tabs}
        activeTab={(filters['filters[ad_type]'] as string) || 'sale'}
        onTabChange={(value) => setFilters('filters[ad_type]', value)}
        isMobile
      />
      <FormSearch defaultFilter={defaultFilter} isMobile />
      <div className={styles.btnBlock}>
        <Button
          color={'white'}
          text={'Показать на карте'}
          className={styles.showMap}
          icon={<Icons.Point />}
          onClick={() => {
            handleSearch('maps');
          }}
        />
        <Button
          text={'Найти'}
          onClick={() => {
            handleSearch();
          }}
        />
      </div>
    </div>
  );
};

export default MainSearchMobile;
